import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate, Link } from 'react-router-dom';
import '../css/StudentDashboard.css';

// ==========================================
// 1. SIDEBAR SUB-COMPONENT
// ==========================================
const Sidebar = () => {
  const userRole = localStorage.getItem('role');
  const userId = localStorage.getItem('userId') || '1';
  const navigate = useNavigate();
  const { id } = useParams(); // URL se :id check karne ke liye
  const location = useLocation();
  
  const dashboardPath = userRole === 'admin' ? '/admin' : `/admin/principal/${userId}`;

  // LOGIC: Agar URL mein koi ID hai, ya state mein viewMode admin hai, aur dekhne wala admin hai, 
  // tabhi pata chalega ki admin kisi aur ka dashboard dekh raha hai.
  const isAdminViewingUser = (id || location.state?.viewMode === "admin") && userRole === "admin";

  return (
    <aside className="sidebar">
      <nav className="nav-menu">
        <Link to={dashboardPath} className="nav-item active" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <span>🏠</span> Dashboard
        </Link>
        <div className="nav-item"><span>🎓</span> My Enrollments</div>
        
        {/* FIX: Return tab sirf tabhi dikhega jab admin kisi aur ka dashboard check kar raha ho */}
        {isAdminViewingUser && (
          <div className="nav-item" onClick={() => navigate('/admin')} style={{ cursor: 'pointer' }}>
            <span>⬅️</span> Return
          </div>
        )}
      </nav>
    </aside>
  );
};

// ==========================================
// 2. UNIFIED PREMIUM PROFILE CARD
// ==========================================
const UnifiedStudentProfileCard = ({ extractedUser, extractedProfile }) => {
  return (
    <div className="premium-profile-card">
      <div className="profile-hero-block">
        <div className="profile-avatar-circle">👩‍🎓</div>
        <div className="profile-core-details">
          <h2 className="student-name-heading">{extractedUser.fullName || "N/A"}</h2>
          <span className="badge-registered-pill">Registered Student</span>
          <div className="quick-contact-meta">
            <p>✉️ {extractedUser.email || "N/A"}</p>
            <p>📞 {extractedUser.phoneNumber || "N/A"}</p>
            <p>📍 {extractedUser.city || "N/A"}{extractedUser.state ? `, ${extractedUser.state}` : ""}</p>
          </div>
        </div>
      </div>

      <div className="vertical-card-divider"></div>

      <div className="profile-extended-grid">
        <div className="grid-meta-row">
          <span className="meta-label">🎓 Qualification:</span>
          <span className="meta-value">
            {extractedProfile.studentQualification || extractedProfile.currentStudyLevel || extractedProfile.currentQualification || extractedUser.studentQualification || extractedUser.qualification || "12th"}
          </span>
        </div>
        <div className="grid-meta-row">
          <span className="meta-label">📚 Interested Course:</span>
          <span className="meta-value">
            {extractedProfile.studentInterestedCourse || extractedProfile.selectStream || extractedProfile.interestedCourse || extractedUser.studentInterestedCourse || extractedUser.interestedCourse || "N/A"}
          </span>
        </div>
        <div className="grid-meta-row">
          <span className="meta-label">🌍 Preferred Country:</span>
          <span className="meta-value">
            {extractedProfile.studentPreferredCountry || extractedProfile.studyLocationPreference || extractedProfile.preferredCountry || extractedUser.studentPreferredCountry || extractedUser.preferredCountry || "India"}
          </span>
        </div>
        <div className="grid-meta-row">
          <span className="meta-label">⏳ Study Timeline:</span>
          <span className="meta-value">
            {extractedProfile.studentStudyTimeline || extractedProfile.preferredIntake || extractedProfile.studyTimeline || extractedUser.studentStudyTimeline || extractedUser.studyTimeline || "2026 Intake"}
          </span>
        </div>
        <div className="grid-meta-row">
          <span className="meta-label">💰 Budget Range:</span>
          <span className="meta-value">
            {extractedProfile.studentBudgetRange || extractedProfile.budgetRange || extractedUser.studentBudgetRange || extractedUser.budgetRange || "10-15 lacs"}
          </span>
        </div>
      </div>
    </div>
  );
};

// ==========================================
// 3. ENROLLMENT LIST ROW CARD
// ==========================================
const EnrollmentCard = ({ enrollment }) => (
  <div className="premium-enrollment-row">
    <div className="uni-brand-block">
      <div className="uni-logo-box">🏛️</div>
      <div className="uni-title-details">
        <h4>{enrollment.universityName}</h4>
        <p className="course-title-text">{enrollment.course}</p>
        <span className="degree-pill">Undergraduate</span>
      </div>
    </div>
    
    <div className="enrollment-meta-middle">
      <div className="meta-data-node">
        <span className="node-label">📅 Enrollment Date</span>
        <span className="node-value">{enrollment.date}</span>
      </div>
      <div className="meta-data-node">
        <span className="node-label">🆔 Enrollment ID</span>
        <span className="node-value">{enrollment.enrollmentId}</span>
      </div>
    </div>

    <div className="enrollment-action-right">
      <span className="status-enrolled-pill">✓ Enrolled</span>
      <button className="btn-view-details-action">View Details</button>
    </div>
  </div>
);

// ==========================================
// MAIN DASHBOARD EXPORT CONTAINER
// ==========================================
const StudentDashboard = () => {
  const { id } = useParams(); 
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  // Initial local checking logic
  const [userData, setUserData] = useState(() => {
    return location.state?.user || location.state?.student || JSON.parse(localStorage.getItem("user"));
  });
  
  const currentViewMode = (id && location.state?.viewMode === "admin") ? "admin" : "student";

  const [dummyEnrollments] = useState([
    { id: 1, universityName: "Amity University, Noida", course: "BBA (Bachelor of Business Administration)", date: "20 May 2026", enrollmentId: "EVR-AMU-2026-001" },
    { id: 2, universityName: "Chandigarh University, Mohali", course: "BCA (Bachelor of Computer Applications)", date: "28 May 2026", enrollmentId: "EVR-CU-2026-002" },
    { id: 3, universityName: "Lovely Professional University, Punjab", course: "MBA (Master of Business Administration)", date: "05 June 2026", enrollmentId: "EVR-LPU-2026-003" }
  ]);

  useEffect(() => {
    // FIX: Check karo ki kya full profile loaded hai ya nahi?
    // Agar city, studentQualification, ya studentProfile missing hai, toh api hit hogi hi hogi.
    const hasFullProfile = userData && (userData.studentProfile || userData.city || userData.studentQualification);
    
    if (currentViewMode === "admin" || !hasFullProfile) {
      fetchDashboardData();
    }
  }, [currentViewMode, id]);

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      let url = 'https://api.satrixstore.in/api/me'; // Default student endpoint
      
      if (currentViewMode === "admin" && id) {
        url = `https://api.satrixstore.in/api/admin/user-details/${id}`;
      }

      const response = await fetch(url, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' 
        }
      });

      const resData = await response.json();
      
      if (response.ok) {
        // Safe check for structure variations
        const comingData = resData.data ? resData.data : resData;
        setUserData(comingData); 
        
        // Student login backup to local storage
        if (currentViewMode !== "admin") {
          localStorage.setItem("user", JSON.stringify(comingData));
        }
      } else {
        console.error("Fetch Error:", resData.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading-screen">Loading eVridya Dashboard...</div>;
  }

  // Pure Structural Builder Mapping
  let userObj = {
    fullName: "Student",
    email: "N/A",
    phoneNumber: "N/A",
    city: "N/A",
    state: "N/A",
    studentQualification: "12th",
    studentInterestedCourse: "N/A",
    studentPreferredCountry: "India",
    studentStudyTimeline: "2026 Intake",
    studentBudgetRange: "10-15 lacs"
  };
  
  let profileObj = {};

  if (userData) {
    // Clean Target Resolver: nested object check
    const cleanTarget = userData.data ? userData.data : (Array.isArray(userData) ? userData[0] : userData);

    if (cleanTarget) {
      userObj = {
        fullName: cleanTarget.fullName || cleanTarget.name || cleanTarget.user?.fullName || cleanTarget.user?.name || userObj.fullName,
        email: cleanTarget.email || cleanTarget.user?.email || userObj.email,
        phoneNumber: cleanTarget.phoneNumber || cleanTarget.phone || cleanTarget.user?.phoneNumber || cleanTarget.user?.phone || userObj.phoneNumber,
        city: cleanTarget.city || cleanTarget.user?.city || userObj.city,
        state: cleanTarget.state || cleanTarget.user?.state || userObj.state,
        studentQualification: cleanTarget.studentQualification || cleanTarget.qualification || cleanTarget.studentProfile?.studentQualification || userObj.studentQualification,
        studentInterestedCourse: cleanTarget.studentInterestedCourse || cleanTarget.interestedCourse || cleanTarget.studentProfile?.studentInterestedCourse || userObj.studentInterestedCourse,
        studentPreferredCountry: cleanTarget.studentPreferredCountry || cleanTarget.preferredCountry || cleanTarget.studentProfile?.studentPreferredCountry || userObj.studentPreferredCountry,
        studentStudyTimeline: cleanTarget.studentStudyTimeline || cleanTarget.studyTimeline || cleanTarget.studentProfile?.studentStudyTimeline || userObj.studentStudyTimeline,
        studentBudgetRange: cleanTarget.studentBudgetRange || cleanTarget.budgetRange || cleanTarget.studentProfile?.studentBudgetRange || userObj.studentBudgetRange
      };
      profileObj = cleanTarget.studentProfile || cleanTarget.profile || cleanTarget;
    }
  }

  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="main-content">
        
        <div className="welcome-header-bar">
          <div className="welcome-txt">
            <p className="welcome-sub">Welcome back,</p>
            <h1>{userObj.fullName} 👋</h1>
          </div>
          <div className="header-right-profile-widget">
            <div className="notif-icon-bell">🔔<span className="notif-count">3</span></div>
            <div className="profile-pill-user">
              <span>{userObj.fullName ? userObj.fullName.split(' ')[0] : 'User'}</span>
              <span className="arrow-down">▼</span>
            </div>
          </div>
        </div>

        <UnifiedStudentProfileCard extractedUser={userObj} extractedProfile={profileObj} />

        <div className="section-title-wrapper">
          <span className="section-icon">🎓</span>
          <div>
            <h3>My Enrollments</h3>
            <p className="section-subtitle">Track all the courses you have enrolled in through eVridya.com</p>
          </div>
        </div>

        <div className="enrollment-rows-stack">
          {dummyEnrollments.map((enrollment) => (
            <EnrollmentCard key={enrollment.id} enrollment={enrollment} />
          ))}
        </div>
      </main>
    </div>
  );
};

export default StudentDashboard;